import React, { useEffect } from 'react';
import { useScrollMemory } from '../hooks/useScrollMemory';

const ScrollMemoryWrapper = ({ children, enableScrollMemory = true, className }) => {
  const { saveCurrentPosition } = useScrollMemory();

  // Set up scroll event listener for window scrolling instead of container scrolling
  useEffect(() => {
    // If scroll memory is disabled, don't set up the listener
    if (!enableScrollMemory) {
      return;
    }

    const handleScroll = () => {
      // Throttled save function
      const throttledSave = () => {
        clearTimeout(throttledSave.timeoutId);
        throttledSave.timeoutId = setTimeout(() => {
          saveCurrentPosition();
        }, 500); // Save every 500ms during scroll
      };
      throttledSave();
    };

    // Add scroll event listener to window
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [saveCurrentPosition, enableScrollMemory]);

  return (
    <div className={className}>
      {children}
    </div>
  );
};

export default ScrollMemoryWrapper;
